export default __webpack_public_path__ + "static/retirement-planning-4-4d62a3e4749a4af06522cca5195c4fef.png";